import React from 'react';
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer
} from 'recharts';
import CustomTooltip from './CustomTooltip';

const EndpointsChart = ({ data, themeColors }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-4 md:p-6 h-[420px] flex flex-col">
      <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-5">
        Top Endpoints
      </h2>
      <div className="h-[325px] mb-3">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            layout="vertical"
            margin={{ top: 5, right: 30, left: 20, bottom: 10 }}
            barSize={32}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" opacity={0.3} />
            <XAxis 
              type="number" 
              stroke="#94a3b8" 
              tick={{ fill: '#94a3b8', fontSize: 12 }}
            />
            <YAxis 
              dataKey="endpoint" 
              type="category" 
              width={80}
              stroke="#94a3b8"
              tick={{ fill: '#94a3b8', fontSize: 12 }} 
            />
            <Tooltip 
              content={<CustomTooltip />} 
              cursor={{ fill: "var(--tooltip-cursor-light)" }}
            />
            <Bar 
              dataKey="count" 
              name="Requests" 
              fill={themeColors.secondary} 
              radius={[0, 4, 4, 0]} 
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default EndpointsChart; 